export namespace KeysService {
  export interface API {
    destroy: () => void;
    disable: () => void;
    enable: () => void;
    isPressed: (key: string) => boolean;
    getPressedKeys: () => string[];
  }

  export enum Modifiers {
    Shift = 'Shift',
    Control = 'Control',
    Alt = 'Alt',
    Meta = 'Meta',
  }
}

export const allowedUnformattedKeyCodes = [
  'Escape',
  'Tab',
  'Backspace',
  'Enter',
  'Backlash',
  'Period',
  'Slash',
  'Comma',
  'Space',
  'Delete',
  'Home',
  'End',
  'PageUp',
  'PageDown',
  'ArrowUp',
  'Numpad8',
  'ArrowDown',
  'Numpad5',
  'ArrowLeft',
  'Numpad4',
  'ArrowRight',
  'Numpad6',
  'BracketLeft',
];

export const clearStateKeys: string[] = [
  KeysService.Modifiers.Meta.toLowerCase(),
  KeysService.Modifiers.Alt.toLowerCase(),
  KeysService.Modifiers.Control.toLowerCase(),
];
